import api from "./app-controller";
import SETTING_ENDPOINTS from "../routes/setting-routes";

export const getCategories = async () => await api.get(SETTING_ENDPOINTS.GET_CATEGORIES);
